<div class="modal-header">
  <h3>
    <span>Connection Profiles</span>
    <button type="button" class="close close-lg pull-right" aria-label="Close"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h3>
</div>
<div class="modal-body row" style="overflow-y: auto; max-height: calc(100vh - 150px);">
  <div style="width:100%; padding-bottom: 12px; min-height: 300px; padding-left: 16px; padding-right: 16px;" class="clearfloat">
    <table class="table table-bordered table-hover table-condensed">
      <thead>
        <tr>
          <th style="width: 3%"></th>
          <th style="width: 37%">Profile Description</th>
          <th style="width: 60%">Profile JSON</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let connectionProfile of connectionProfiles$ | async">
          <td>
            <input type="radio" [name]="connectionProfile.profileId" id="{{connectionProfile.profileId}}"
                   (change)="onChange()"
                   (click)="selectedConnectionProfile = connectionProfile.profileDescription"
                   [checked]="setSelectedId(selectedConnectionProfile === connectionProfile.profileDescription, connectionProfile.profileId)"
                   [value]="connectionProfile.profileId"
                   [(ngModel)]="connectionProfileId">
          <td>{{connectionProfile.profileDescription}}</td>
          <td style="width: 60%"><pre>{{connectionProfile.profileDetailsJSON | json}}</pre></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <button
      class="btn btn-primary" aria-hidden="true" (click)="saveChanges()"
      [disabled]="!isUpdated"
      style="margin-right: 16px;">
    Save Changes
  </button>
  <div class="pull-right">
    <div class="pull-right">
      <button class="btn btn-default btn-cancel"
              (click)="onCancel()">
        <span *ngIf="isUpdated">Cancel</span><span *ngIf="!isUpdated">Close</span>
      </button>
    </div>
  </div>
</div>